import SliderNumberRange from './SliderNumberRange';

export { SliderNumberRange };
